import {
  Component,
  ElementRef,
  forwardRef,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  ViewContainerRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { debounce } from 'lodash';

export class FormSelectOption {
  option: string | number | any;
  value: string;
  icon?: string;
  [key: string]: any;
}

@Component({
  selector: 'app-form-select',
  template: `
    <input
      type="text"
      class="hidden-input"
      [(ngModel)]="search"
      [class.--show]="search && dropdownToggle"
      #hidden
      data-id="form-select-input"
    />
    <p class="input-title" *ngIf="title">{{ title }}</p>
    <div class="form-input" [class.placeholder]="!value" (click)="dropdownToggler()">
      {{ search && dropdownToggle ? '' : getName(value) || placeholder }}
      <div class="dropdown-caret"><i class="fa fa-chevron-down"></i></div>
    </div>
    <nav class="dropdown-list" [class.visible]="dropdownToggle" #dropdownList>
      <a
        href="#"
        *ngFor="let item of (options | selectSearch: search)"
        class="dropdown-link"
        [class.--active]="item.option == value"
        (click)="select(item, $event)"
        data-id="form-select-option-{{ item.option }}"
      >
        <i *ngIf="item.icon" [class]="item.icon"></i> {{ item.value }}
      </a>
      <div class="dropdown-link" *ngIf="(options | selectSearch: search).length === 0">No results found!</div>
    </nav>
    <p class="input-error" *ngIf="error">{{ error }}</p>
  `,
  styleUrls: ['./form-select.template.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormSelectComponent),
      multi: true,
    },
  ],
  host: {
    '(document:click)': 'onClickOutside($event)',
  },
})
export class FormSelectComponent implements ControlValueAccessor {
  @Input() title: string;
  @Input() type: string = 'text';
  @Input() disabled: boolean = false;
  @Input() placeholder: string = '';
  @Input() error: string = '';
  @Input() options: Array<FormSelectOption> = [];
  @Input() startAt: number;
  @Input('value') _value = '';
  @ViewChild('hidden') hiddenElement: ElementRef;
  @ViewChild('dropdownList') dropdownList: ElementRef;
  @Output() changed = new EventEmitter<boolean>();

  dropdownToggle: boolean = false;
  search: string = '';
  emitChangeEvent = debounce(item => {
    return this.changed.emit(item);
  }, 100);

  dropdownToggler() {
    this.dropdownToggle = !this.dropdownToggle;
    if (this.dropdownToggle) {
      if (this.startAt && this.startAt <= this.dropdownList.nativeElement.children.length - 1) {
        setTimeout(() => {
          let scrollTop = 0;
          for (let i = 0; i < this.startAt; i++) {
            scrollTop += this.dropdownList.nativeElement.children[i].offsetHeight;
          }
          this.dropdownList.nativeElement.scrollTo(0, scrollTop);
        }, 100);
      }
      this.search = '';
      this.hiddenElement.nativeElement.focus();
    }
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  get value() {
    return this._value;
  }

  set value(val: any) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }

  constructor(private eRef: ElementRef) {}

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  writeValue(value: any) {
    if (value) {
      this.value = value;
    }
  }

  onBlur() {
    this.onTouched();
  }

  onClickOutside(event: any) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.dropdownToggle = false;
    }
  }

  select(item: any, event?: any) {
    if (event) {
      event.preventDefault();
    }
    this.emitChangeEvent(item);
    this.dropdownToggle = false;
    this.value = item.option;
  }

  getName(val: string) {
    if (!val) {
      return false;
    }
    const filtered = this.options.filter(item => item.option === val);
    if (!filtered.length) {
      return false;
    }
    return filtered[0].value;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/form/inputs/form-select.component.ts